import React from 'react';
import styles from './Hero.module.scss';
import { Button } from '../../../components/Button/Button';
import { HeroCarousel } from './HeroCarousel';
import checkDaylight from '../../../images/business-solutions-check-daylight.png';
import { scrollToBusinessInquiryForm } from '../../../components/Header/BusinessSolutionsHeader';
import hero1D from '../../../images/business-solutions-hero-1-d.jpg';
import hero1M from '../../../images/business-solutions-hero-1-m.jpg';
import hero2D from '../../../images/business-solutions-hero-2-d.jpg';
import hero2M from '../../../images/business-solutions-hero-2-m.jpg';
import hero3D from '../../../images/business-solutions-hero-3-d.jpg';
import hero3M from '../../../images/business-solutions-hero-3-m.jpg';
import hero4D from '../../../images/business-solutions-hero-4-d.jpg';
import hero4M from '../../../images/business-solutions-hero-4-m.jpg';

const badges = ['Built for Business', 'Symmetrical Speeds', 'Local Support'];

const slides = [
  {
    image: { mobile: hero1M, desktop: hero1D },
    alt: 'Small business owner smiling as she hands back a customer\'s card reader at the counter',
    caption: 'Reliable fiber for day to day business.',
    subcaption: 'Built for smaller teams that need dependable speed and local support.',
  },
  {
    image: { mobile: hero3M, desktop: hero3D },
    alt: 'Two business owners reviewing performance data together on a tablet',
    caption: 'Keep business moving with more bandwidth.',
    subcaption: 'Designed for teams running cloud tools, payments, calls, and connected devices.',
  },
  {
    image: { mobile: hero2M, desktop: hero2D },
    alt: 'Coffee shop storefront with a connected device visible in the window',
    caption: 'Connectivity ready for customer facing spaces.',
    subcaption: 'A cleaner internet experience for shops, cafés, and shared business locations.',
  },
  {
    image: { mobile: hero4M, desktop: hero4D },
    alt: 'Exterior of a modern office building with landscaped grounds',
    caption: 'Enterprise-ready connectivity.',
    subcaption: 'Scalable fiber internet options for larger buildings and high-demand operations.',
  },
];

const scrollToPackages = (): void => {
  const el = document.getElementById('packages');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export const Hero = (): React.JSX.Element => {
  return (
    <section className={styles.hero}>
      <div className="grid-12">
        <div className={styles.container}>
          <div className={styles.copy}>
            <p className={styles.eyebrow}>Cityside Fiber Business Solutions</p>

            <h1 className={styles.headline}>
              <span className="color--med-blue">More Speed, Less Hassle.</span>
              <br />
              <span className="color--marina-blue">Better Business Starts Here.</span>
            </h1>

            <p className={styles.subtext}>
              Fast, reliable business internet with local support you can count on.
            </p>

            <ul className={styles.badges}>
              {badges.map((badge) => (
                <li key={badge}>
                  <img src={checkDaylight} alt="" width="22" height="22" loading="lazy" />
                  {badge}
                </li>
              ))}
            </ul>

            <div className={styles.ctas}>
              <Button size="lg" className="bg-color--orange" onClick={scrollToBusinessInquiryForm}>
                Inquire Today
              </Button>
              <Button size="lg" className="bg-color--med-blue" onClick={scrollToPackages}>
                Explore Service Tiers
              </Button>
            </div>
          </div>

          <div className={styles.visual}>
            <HeroCarousel slides={slides} />
          </div>
        </div>
      </div>
    </section>
  );
};
